import { GAME_NIGHT_QUESTS } from './game-night';
import { MASTER_BUILDERS_QUESTS } from './master-builders';
import { STANDARD_TEAM_UP_QUESTS } from './standard';

export const TEAM_UP_QUESTS = [
    ...GAME_NIGHT_QUESTS,
    ...MASTER_BUILDERS_QUESTS,
    ...STANDARD_TEAM_UP_QUESTS,
];
